import { useParams } from "react-router-dom";
import {
  Flex,
  Image,
  Input,
  Text,
  Icon,
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
  Spinner,
  Avatar,
} from "@chakra-ui/react";
import { Tooltip } from "@chakra-ui/react";
import ReactTimeAgo from "react-time-ago";
import { useRef, useContext, useState, useEffect } from "react";
import swal from "sweetalert";
import { Divider } from "@chakra-ui/react";
import { BiTrash, BiArrowBack } from "react-icons/bi";
import uv from "../resources/imgs/uv.png";
import dv from "../resources/imgs/dv.png";
import { useToast } from "@chakra-ui/react";

import AuthContext from "../store/auth";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "ckeditor5-build-full";
import { useHotkeys } from "react-hotkeys-hook";
import Breadcrumbs from "../components/BreadCrumbs";
import { Url } from '../store/global';

const Approval = () => {
  const toast = useToast();
  let { pageSlug } = useParams();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const {
    isOpen: isOpen2,
    onOpen: onOpen2,
    onClose: onClose2,
  } = useDisclosure();
  const {
    isOpen: isOpen3,
    onOpen: onOpen3,
    onClose: onClose3,
  } = useDisclosure();
  const {
    isOpen: isOpen4,
    onOpen: onOpen4,
    onClose: onClose4,
  } = useDisclosure();

  const [pageInfo, setPageInfo] = useState();

  const [hasApproved, setHasApproved] = useState();

  const [approvalState, setApprovalState] = useState(0);
  const [dropdown, setDropdown] = useState();
  const [question, setQuestion] = useState([]);

  const [isc, setIsc] = useState(false);
  const [isa, setIsa] = useState(false);

  const [answer, setAnswer] = useState();

  const questionRef = useRef();
  const answerRef = useRef();

  const authCtx = useContext(AuthContext);

  const [value, setValue] = useState("");
  const editorHandler = (e, editor) => {
    console.log(editor.getData());
    setValue(editor.getData());
  };

  const voteQuestion = (id, up) => {
    let type = "random";
    up === "up" ? (type = "up_vote") : (type = "down_vote");
    fetch({Url}.Url+"/vote_on_question/", {
      method: "POST",
      body: JSON.stringify({
        question_id: id,
        vote: type + "s",
      }),
      headers: {
        "Content-Type": "application/json",
        Authorization: "Token " + authCtx.token,
      },
    }).then((response) =>
      response
        .json()
        .then((data) => ({
          data: data,
          status: response.status,
        }))
        .then((res) => {
          if (res.status < 300) {
            toast({
              title: "Your " + type + " has been recorded successfully!",
              description: "congratulations!",
              status: "success",
              duration: 2000,
              isClosable: true,
              position: "top-right",
              onCloseComplete: () => {
                setApprovalState(approvalState + 1);
                console.log(approvalState);
              },
            });
            // .then(() => {

            // });
          } else {
            toast({
              title: "Registration failed.",
              description: "Something went wrong",
              status: "error",
              position: "top-right",
              duration: 2000,
              isClosable: true,
              position: "top-right",
            });
          }
        })
    );
  };

  const emailA = useRef();

  const createApprovalPage = () => {
    fetch({Url}.Url+"/create_approvals/", {
      method: "POST",
      body: JSON.stringify({
        page_id: pageSlug,
        approvers: emailA.current.value,
      }),
      headers: {
        "Content-Type": "application/json",
        Authorization: "Token " + authCtx.token,
      },
    }).then((response) =>
      response
        .json()
        .then((data) => ({
          data: data,
          status: response.status,
        }))
        .then((res) => {
          if (res.status < 300) {
            toast({
              title: "Approval Blocks created successfully!",
              description: "congratulations!",
              status: "success",
              position: "top-right",
              duration: 2000,
              isClosable: true,
              position: "top-right",
              onCloseComplete: () => {
                window.location.reload();
              },
            });
            // .then(() => {
            //   window.location.reload();
            // });
          } else {
            toast({
              title: "Creating some approvers failed.",
              description: res.data.detail,
              status: "error",
              position: "top-right",
              duration: 2000,
              isClosable: true,
              position: "top-right",
            });
          }
        })
    );
  };
  const createReApprovalPage = (e) => {
    fetch({Url}.Url+"/create_approvals/", {
      method: "POST",
      body: JSON.stringify({
        page_id: pageSlug,
        approvers: e,
      }),
      headers: {
        "Content-Type": "application/json",
        Authorization: "Token " + authCtx.token,
      },
    }).then((response) =>
      response
        .json()
        .then((data) => ({
          data: data,
          status: response.status,
        }))
        .then((res) => {
          if (res.status < 300) {
            toast({
              title: "Approval Blocks created successfully!",
              description: "congratulations!",
              status: "success",
              position: "top-right",
              duration: 2000,
              isClosable: true,
              position: "top-right",
              onCloseComplete: () => {
                window.location.reload();
              },
            });
            // .then(() => {
            //   window.location.reload();
            // });
          } else {
            toast({
              title: "Creating some approvers failed.",
              description: res.data.detail,
              status: "error",
              position: "top-right",
              duration: 2000,
              isClosable: true,
              position: "top-right",
            });
          }
        })
    );
  };

  const handleRemAppr = (em) => {
    fetch(
      {Url}.Url+"/delete_approval/" + pageSlug + "/",
      {
        method: "POST",
        body: JSON.stringify({
          email: em,
        }),
        headers: {
          "Content-Type": "application/json",
          Authorization: "Token " + authCtx.token,
        },
      }
    ).then((response) =>
      response
        .json()
        .then((data) => ({
          data: data,
          status: response.status,
        }))
        .then((res) => {
          if (res.status < 300) {
            toast({
              title: "Approval Block deleted successfully!",
              description: "congratulations!",
              status: "success",
              position: "top-right",
              duration: 2000,
              isClosable: true,
              position: "top-right",
              onCloseComplete: () => {
                window.location.reload();
              },
            }).then(() => {
              window.location.reload();
            });
          } else {
            toast({
              title: "Deleting some approvers failed.",
              description: res.data.detail,
              status: "error",
              position: "top-right",
              duration: 2000,
              isClosable: true,
              position: "top-right",
            });
          }
        })
    );
  };

  const approvePage = () => {
    fetch({Url}.Url+"/approve/" + pageSlug + "/", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Token " + authCtx.token,
      },
    }).then((response) =>
      response
        .json()
        .then((data) => ({
          data: data,
          status: response.status,
        }))
        .then((res) => {
          if (res.status < 300) {
            toast({
              title: "Block approved successfully!",
              description: "congratulations!",
              status: "success",
              position: "top-right",
              duration: 2000,
              isClosable: true,
              position: "top-right",
              onCloseComplete: () => {
                window.location.reload();
              },
            }).then(() => {
              window.location.reload();
            });
          } else {
            toast({
              title: "Approval failed.",
              description: "Something went wrong.",
              status: "error",
              position: "top-right",
              duration: 2000,
              isClosable: true,
              position: "top-right",
            });
          }
        })
    );
  };

  const disapprovePage = () => {
    fetch({Url}.Url+"/disapprove/" + pageSlug + "/", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Token " + authCtx.token,
      },
    }).then((response) =>
      response
        .json()
        .then((data) => ({
          data: data,
          status: response.status,
        }))
        .then((res) => {
          if (res.status < 300) {
            toast({
              title: "Block approval reversed successfully!",
              description: "congratulations!",
              status: "success",
              position: "top-right",
              duration: 2000,
              isClosable: true,
              position: "top-right",
              onCloseComplete: () => {
                window.location.reload();
              },
            });
            // .then(() => {
            //   window.location.reload();
            // });
          } else {
            toast({
              title: "Approval reversal failed.",
              description: "Something went wrong.",
              status: "error",
              duration: 2000,
              isClosable: true,
              position: "top-right",
            });
          }
        })
    );
  };

  const postQuestion = () => {
    // const ques = questionRef.current.value;
    fetch({Url}.Url+"/create_question/", {
      method: "POST",
      body: JSON.stringify({
        question: value.toString("html"),
        page_id: pageSlug,
      }),
      headers: {
        "Content-Type": "application/json",
        Authorization: "Token " + authCtx.token,
      },
    }).then((response) =>
      response
        .json()
        .then((data) => ({
          data: data,
          status: response.status,
        }))
        .then((res) => {
          if (res.status < 300) {
            onClose();
            toast({
              title: "Question added successfully!",
              description: "congratulations!",
              status: "success",
              duration: 2000,
              isClosable: true,
              position: "top-right",
              onCloseComplete: () => {
                window.location.reload();
              },
            }).then(() => {
              window.location.reload();
            });
          } else {
            toast({
              title: "Registration failed.",
              description: "Something went wrong.",
              status: "error",
              duration: 2000,
              isClosable: true,
              position: "top-right",
            });
            // swal('Registration failed.', 'Something went wrong.', 'error');
          }
        })
    );
  };

  const postAnswer = () => {
    const ans = answerRef.current.value;
    fetch({Url}.Url+"/create_answer/", {
      method: "POST",
      body: JSON.stringify({
        question_id: answer,
        answer: ans,
      }),
      headers: {
        "Content-Type": "application/json",
        Authorization: "Token " + authCtx.token,
      },
    }).then((response) =>
      response
        .json()
        .then((data) => ({
          data: data,
          status: response.status,
        }))
        .then((res) => {
          if (res.status < 300) {
            toast({
              title: "Answer added successfully!",
              description: "congratulations!",
              status: "success",
              duration: 2000,
              isClosable: true,
              position: "top-right",
            });

            // swal('Answer added successfully!', 'congratulations!', 'success').then(() => {
            //   window.location.reload();
            // });
          } else {
            toast({
              title: "Registration failed.",
              description: "Something went wrong.",
              status: "error",
              duration: 2000,
              isClosable: true,
              position: "top-right",
            });

            // swal('Registration failed.', 'Something went wrong.', 'error');
          }
        })
    );
  };
  useEffect(() => {
    getPageInformation();
  }, [postAnswer]);
  const answerHandler = (id) => {
    onOpen2();
    setAnswer(id);
  };

  const submitAnswer = () => {
    onClose2();
    postAnswer(answer);
  };

  const questionHandler = (id) => {
    onOpen4();
    // setQuestion(id);
    // console.log(id)
    setQuestion([]);
    fetch({Url}.Url+"/question_page/" + id, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Token " + authCtx.token,
      },
    }).then((response) =>
      response
        .json()
        .then((data) => ({
          data: data,
          status: response.status,
        }))
        .then((res) => {
          if (res.status < 300) {
            setQuestion(res.data);
            // console.log(res.data);
          } else {
            toast({
              title: "Oops, something went wrong!",
              description: res.data.detail,
              status: "error",
              duration: 2000,
              isClosable: true,
              position: "top-right",
            });

            // swal('Oops, something went wrong!', res.data.detail, 'error');
          }
        })
    );
  };

  const getPageInformation = () => {
    fetch({Url}.Url+"/approval_page/" + pageSlug, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Token " + authCtx.token,
      },
    }).then((response) =>
      response
        .json()
        .then((data) => ({
          data: data,
          status: response.status,
        }))
        .then((res) => {
          if (res.status < 300) {
            setPageInfo(res.data);
            console.log(res.data);
            setIsa(res.data.is_approver);
            // console.log(isa);
            setIsc(res.data.is_collaborator);
            setHasApproved(res.data.has_approved);
            // console.log(isc);
            setDropdown(res.data.dropdown_list);
            if (!res.data.is_approver && !res.data.is_collaborator) {
              toast({
                title: "Oops, something went wrong!",
                description: "You don't have permission to view this page.",
                status: "error",
                button: "Back tp Dashboard",
                duration: 2000,
                isClosable: true,
                position: "top-right",
                onCloseComplete: () => {
                  window.location = "/";
                },
              });
            }
          } else {
            toast({
              title: "Oops, something went wrong!",
              description: res.data.detail,
              status: "error",
              duration: 2000,
              isClosable: true,
              position: "top-right",
            });
          }
        })
    );
  };

  // runs on initial page load
  useEffect(() => {
    getPageInformation();
    // eslint-disable-next-line
  }, [approvalState]);

  // shortcuts
  useHotkeys("alt+x", () => {
    window.location = "/page/" + pageSlug;
  });
  useHotkeys("option+x", () => {
    window.location = "/page/" + pageSlug;
  });
  useHotkeys("option+n", () => {
    onOpen3();
  });

  useHotkeys("alt+n", () => {
    onOpen3();
  });

  const breadcrumbs = [
    { path: "/", breadcrumb: "Home" },
    { path: "/library", breadcrumb: "Library" },
    {
      path: "/project/" + pageInfo?.page.project?.id,
      breadcrumb: pageInfo?.page.project?.title,
    },
    { path: "/page/" + pageInfo?.page.id, breadcrumb: pageInfo?.page.title },
    {
      path: "/approval/" + pageInfo?.page.id,
      breadcrumb: "Approval",
      end: true,
    },
  ];

  // console.log(pageInfo);
  return (
    <>
      <Flex
        backgroundColor="bg"
        flexDir="column"
        alignItems="center"
        minHeight="100vh"
        height="fit-content"
        width="100%"
      >
        <Flex
          width={{ base: "100%", lg: "95%" }}
          height="fit-content"
          flexDir="column"
          justifyContent="space-between"
          px="10px"
        >
          <Flex
            w="100%"
            color="white"
            fontWeight="400"
            alignItems="center"
            justifyContent="space-between"
          >
            {pageInfo && <Breadcrumbs breadcrumbs={breadcrumbs} />}
          </Flex>
          {pageInfo ? (
            <Flex
              width={["99%", "99%", "100%", "100%", "100%"]}
              flexDir="column"
              mr="10px"
            >
              <Flex
                flexDir={{ base: "column", md: "row" }}
                justifyContent={{ md: "space-between" }}
                alignItems={{ md: "center" }}
                borderBottom="2px solid  rgba(255, 255, 255, 0.24)"
              >
                <Text color="main.text" fontSize="24px" fontWeight="700">
                  Approval Page
                </Text>
                <Flex flexDir="row" mb={1}>
                  {isa && (
                    <>
                      {hasApproved ? (
                        <>
                          <Button
                            bg="background.yellow1"
                            mr={2}
                            color="white"
                            onClick={disapprovePage}
                          >
                            Reverse Approval
                          </Button>
                        </>
                      ) : (
                        <Button
                          bg="background.yellow1"
                          mr={2}
                          color="white"
                          onClick={approvePage}
                        >
                          <svg
                            width="16"
                            height="16"
                            viewBox="0 0 18 18"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M8.29688 0.5625H9.70312C9.82812 0.5625 9.89062 0.625 9.89062 0.75V17.25C9.89062 17.375 9.82812 17.4375 9.70312 17.4375H8.29688C8.17187 17.4375 8.10938 17.375 8.10938 17.25V0.75C8.10938 0.625 8.17187 0.5625 8.29688 0.5625Z"
                              fill="white"
                            />
                            <path
                              d="M1.125 8.10938H16.875C17 8.10938 17.0625 8.17187 17.0625 8.29688V9.70312C17.0625 9.82813 17 9.89062 16.875 9.89062H1.125C1 9.89062 0.9375 9.82813 0.9375 9.70312V8.29688C0.9375 8.17187 1 8.10938 1.125 8.10938Z"
                              fill="white"
                            />
                          </svg>
                          &nbsp;Approve this Page
                        </Button>
                      )}
                    </>
                  )}

                  <Button bg="background.grey0" color="white" onClick={onOpen3}>
                    <svg
                      width="22"
                      height="20"
                      viewBox="0 0 22 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M19.8187 14.2469C18.8226 13.6703 17.6085 13.825 16.7906 14.5469L15.5484 13.8273V10.2719C15.5484 9.90391 15.3515 9.56172 15.0328 9.37891L11.8453 7.54375V5.97109C12.8812 5.61953 13.6265 4.63984 13.6265 3.48438C13.6265 2.03359 12.4523 0.859375 11.0015 0.859375C9.55073 0.859375 8.37651 2.03359 8.37651 3.48438C8.37651 4.63984 9.12183 5.61953 10.1578 5.97109V7.54375L6.97026 9.37891C6.65151 9.56172 6.45464 9.90391 6.45464 10.2719V13.825L5.21245 14.5445C4.39448 13.8227 3.17808 13.668 2.18433 14.2445C0.93042 14.9711 0.503858 16.5742 1.22339 17.8281C1.94526 19.082 3.54136 19.5133 4.79058 18.7891C5.78667 18.2125 6.26011 17.0781 6.04683 16.0047L7.18823 15.3414L10.4835 17.2398C10.6429 17.3313 10.821 17.3781 10.9992 17.3781C11.1773 17.3781 11.3554 17.3313 11.5148 17.2398L14.8078 15.3438L15.9492 16.007C15.7359 17.0781 16.2117 18.2148 17.2054 18.7914C18.4546 19.5156 20.0531 19.0867 20.7726 17.8305C21.4945 16.5742 21.0679 14.9711 19.8187 14.2469ZM4.04526 17.4906C3.91796 17.5644 3.77733 17.6122 3.63148 17.6313C3.48562 17.6505 3.33741 17.6406 3.19538 17.6023C3.05335 17.564 2.92031 17.4979 2.80391 17.408C2.68751 17.318 2.59005 17.2059 2.51714 17.0781C2.20776 16.5414 2.39058 15.8523 2.9273 15.543C3.0546 15.4692 3.19522 15.4214 3.34108 15.4022C3.48694 15.3831 3.63515 15.3929 3.77718 15.4313C3.91921 15.4696 4.05225 15.5357 4.16865 15.6256C4.28505 15.7156 4.38251 15.8277 4.45542 15.9555C4.7648 16.4922 4.58198 17.1812 4.04526 17.4906ZM9.87417 3.48438C9.88018 3.18998 10.0013 2.90968 10.2117 2.7036C10.422 2.49753 10.7047 2.38211 10.9992 2.38211C11.2936 2.38211 11.5763 2.49753 11.7867 2.7036C11.997 2.90968 12.1182 3.18998 12.1242 3.48438C12.1182 3.77877 11.997 4.05907 11.7867 4.26515C11.5763 4.47122 11.2936 4.58664 10.9992 4.58664C10.7047 4.58664 10.422 4.47122 10.2117 4.26515C10.0013 4.05907 9.88018 3.77877 9.87417 3.48438ZM13.8585 13.9422L10.9992 15.5898L8.1398 13.9422V10.6516L10.9992 9.00391L13.8585 10.6516V13.9422ZM19.4812 17.0805C19.1718 17.6172 18.4875 17.8023 17.9531 17.493C17.4187 17.1836 17.2335 16.4945 17.5429 15.9578C17.8523 15.4211 18.5367 15.2359 19.071 15.5453C19.6078 15.8547 19.7906 16.5414 19.4812 17.0805Z"
                        fill="white"
                      />
                    </svg>
                    &nbsp; Add Approvers
                  </Button>
                </Flex>
              </Flex>
              <Flex flexDir="column" mt={5} mb={3}>
                <Flex
                  flexDir={{ base: "column", md: "row" }}
                  justifyContent={{ md: "space-between" }}
                  alignItems={{ md: "start" }}
                >
                  <Flex
                    flexDir="column"
                    flexWrap="wrap"
                    width="100%"
                    maxWidth="450px"
                    mr={5}
                  >
                    <Text
                      color="white"
                      fontSize="18px"
                      fontWeight="700"
                      mb="5px"
                      textTransform="upperCase"
                    >
                      Approvers
                    </Text>
                    {pageInfo.approvals.map((app, key) => (
                      <Flex
                        key={key}
                        direction="row"
                        justifyContent="space-between"
                        alignItems="center"
                        color="white"
                        p={4}
                        my={2}
                        bg={app.approved ? "#377336" : "#733636"}
                        borderRadius="7px"
                      >
                        <Flex flexDir="row" alignItems="center">
                          <Flex
                            color="white"
                            fontSize="20px"
                            fontWeight="700"
                            flexDir="row"
                            alignItems="center"
                          >
                            <Avatar
                              size="sm"
                              bg="white"
                              name={app?.approver.name}
                              src={app?.approver.name}
                              color="#2D3842"
                              fontWeight="700"
                              mr={2}
                            />
                            <Flex flexDir="column">
                              <Text
                                color="white"
                                fontSize="16px"
                                fontWeight="700"
                              >
                                {app.approver.name}
                              </Text>
                              <Text
                                color="#FFFFFFBA"
                                fontSize="14px"
                                fontWeight="500"
                              >
                                {app.approver.email}
                              </Text>
                            </Flex>
                          </Flex>
                        </Flex>

                        {pageInfo.is_collaborator ? (
                          <>
                            {" "}
                            <Flex
                              cursor="pointer"
                              onClick={() =>
                                createReApprovalPage(app.approver.email)
                              }
                            >
                              <Tooltip label="Re request for approval">
                                <svg
                                  viewBox="0 0 1024 1024"
                                  fill="currentColor"
                                  height="21"
                                  width="20"
                                >
                                  <path d="M909.1 209.3l-56.4 44.1C775.8 155.1 656.2 92 521.9 92 290 92 102.3 279.5 102 511.5 101.7 743.7 289.8 932 521.9 932c181.3 0 335.8-115 394.6-276.1 1.5-4.2-.7-8.9-4.9-10.3l-56.7-19.5a8 8 0 00-10.1 4.8c-1.8 5-3.8 10-5.9 14.9-17.3 41-42.1 77.8-73.7 109.4A344.77 344.77 0 01655.9 829c-42.3 17.9-87.4 27-133.8 27-46.5 0-91.5-9.1-133.8-27A341.5 341.5 0 01279 755.2a342.16 342.16 0 01-73.7-109.4c-17.9-42.4-27-87.4-27-133.9s9.1-91.5 27-133.9c17.3-41 42.1-77.8 73.7-109.4 31.6-31.6 68.4-56.4 109.3-73.8 42.3-17.9 87.4-27 133.8-27 46.5 0 91.5 9.1 133.8 27a341.5 341.5 0 01109.3 73.8c9.9 9.9 19.2 20.4 27.8 31.4l-60.2 47a8 8 0 003 14.1l175.6 43c5 1.2 9.9-2.6 9.9-7.7l.8-180.9c-.1-6.6-7.8-10.3-13-6.2z" />
                                </svg>
                              </Tooltip>
                            </Flex>
                            <Flex
                              cursor="pointer"
                              onClick={() => handleRemAppr(app.approver.email)}
                            >
                              <Tooltip label="delete">
                                <svg
                                  width="20"
                                  height="21"
                                  viewBox="0 0 24 26"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M7.25 2.75H7C7.1375 2.75 7.25 2.6375 7.25 2.5V2.75H16.75V2.5C16.75 2.6375 16.8625 2.75 17 2.75H16.75V5H19V2.5C19 1.39688 18.1031 0.5 17 0.5H7C5.89687 0.5 5 1.39688 5 2.5V5H7.25V2.75ZM23 5H1C0.446875 5 0 5.44688 0 6V7C0 7.1375 0.1125 7.25 0.25 7.25H2.1375L2.90938 23.5938C2.95938 24.6594 3.84063 25.5 4.90625 25.5H19.0938C20.1625 25.5 21.0406 24.6625 21.0906 23.5938L21.8625 7.25H23.75C23.8875 7.25 24 7.1375 24 7V6C24 5.44688 23.5531 5 23 5ZM18.8531 23.25H5.14688L4.39062 7.25H19.6094L18.8531 23.25Z"
                                    fill="white"
                                  />
                                </svg>
                              </Tooltip>
                            </Flex>
                          </>
                        ) : null}

                        {/* {pageInfo.is_collaborator ? (
                            <Flex
                          cursor="pointer"
                          onClick={() => handleRemAppr(app.approver.email)}
                        >
                            <Tooltip label="delete">
                              <svg
                                width="20"
                                height="21"
                                viewBox="0 0 24 26"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M7.25 2.75H7C7.1375 2.75 7.25 2.6375 7.25 2.5V2.75H16.75V2.5C16.75 2.6375 16.8625 2.75 17 2.75H16.75V5H19V2.5C19 1.39688 18.1031 0.5 17 0.5H7C5.89687 0.5 5 1.39688 5 2.5V5H7.25V2.75ZM23 5H1C0.446875 5 0 5.44688 0 6V7C0 7.1375 0.1125 7.25 0.25 7.25H2.1375L2.90938 23.5938C2.95938 24.6594 3.84063 25.5 4.90625 25.5H19.0938C20.1625 25.5 21.0406 24.6625 21.0906 23.5938L21.8625 7.25H23.75C23.8875 7.25 24 7.1375 24 7V6C24 5.44688 23.5531 5 23 5ZM18.8531 23.25H5.14688L4.39062 7.25H19.6094L18.8531 23.25Z"
                                  fill="white"
                                />
                              </svg>
                              
                            </Tooltip>
                            </Flex>
                          ) : null} */}
                      </Flex>
                    ))}
                  </Flex>
                  <Flex flexDir="column" width="100%" maxWidth="700px">
                    <Text color="white" fontSize="18px" fontWeight="700">
                      QUESTIONS
                    </Text>
                    <Flex flexDir="column" overflowY="auto">
                      {pageInfo.questions.map((q, key) => (
                        <Flex
                          bg="background.grey3"
                          p={4}
                          my={3}
                          alignItems="start"
                          justifyContent="flex-beteween"
                          borderRadius="10PX"
                          flexDir="row"
                          cursor="pointer"
                          // onClick={() => questionHandler(q.id)}
                        >
                          <Flex
                            flexDir="column"
                            width="30px"
                            alignItems="center"
                            mt="7px"
                          >
                            <Image
                              src={uv}
                              boxSize="15px"
                              onClick={() => voteQuestion(q.id, "up")}
                              cursor="pointer"
                            />
                            <Text
                              color="white"
                              fontSize="18px"
                              fontWeight="900"
                            >
                              {q.votes}
                            </Text>
                            <Image
                              src={dv}
                              boxSize="15px"
                              onClick={() => voteQuestion(q.id, "down")}
                              cursor="pointer"
                            />
                          </Flex>

                          <Flex
                            flexDir="column"
                            ml="20px"
                            mr="20px"
                            width="100%"
                          >
                            <Text
                              color="white"
                              fontSize="19px"
                              lineHeight="1.4"
                              fontWeight="700"
                              dangerouslySetInnerHTML={{ __html: q.question }}
                            />

                            <Text
                              color="white"
                              fontSize="12px"
                              fontWeight="900"
                            >
                              Asked By: {q.author.name}
                            </Text>
                            {/* // borderTop={q?.answers?.length > 0 ?"2px solid  rgba(255, 255, 255, 0.24)":null} */}

                            {q?.answers?.length > 0 ? (
                              <Divider
                                orientation="horizontal"
                                style={{
                                  border:
                                    "1px solid  rgba(255, 255, 255, 0.44)",
                                  marginTop: "2%",
                                }}
                              />
                            ) : null}
                            {q.answers.map((a) => (
                              <>
                                <Text
                                  color="white"
                                  fontSize="15px"
                                  lineHeight="1.4"
                                  fontWeight="500"
                                  mt="5px"
                                >
                                  {a.answer}
                                </Text>

                                <Text
                                  color="rgba(255, 255, 255, 0.74)"
                                  p="2px"
                                  borderRadius="10px"
                                  width="fit-content"
                                  pr="5px"
                                  fontSize="12px"
                                  lineHeight="1.4"
                                  fontWeight="700"
                                  mt="2px"
                                  mb="10px"
                                >
                                  By {a.author.email},{" "}
                                  <ReactTimeAgo
                                    date={a.created_on}
                                    locale="en-US"
                                  />
                                  .
                                </Text>
                              </>
                            ))}
                            <Flex
                              flexDir="row"
                              bg
                              mt={3}
                              justifyContent="space-between"
                              alignItems="center"
                              // borderTop={q?.answers?.length > 0 ?"2px solid  rgba(255, 255, 255, 0.24)":null}
                            >
                              {q?.answers?.length >= 0 ? (
                                <Flex mt={3}>
                                  <Button
                                    bg="background.yellow1"
                                    mt="10px"
                                    size="sm"
                                    color="white"
                                    width="150px"
                                    mr="3"
                                    onClick={() => answerHandler(q.id)}
                                  >
                                    <svg
                                      width="18"
                                      height="18"
                                      viewBox="0 0 18 18"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M8.29688 0.5625H9.70312C9.82812 0.5625 9.89062 0.625 9.89062 0.75V17.25C9.89062 17.375 9.82812 17.4375 9.70312 17.4375H8.29688C8.17187 17.4375 8.10938 17.375 8.10938 17.25V0.75C8.10938 0.625 8.17187 0.5625 8.29688 0.5625Z"
                                        fill="white"
                                      />
                                      <path
                                        d="M1.125 8.10938H16.875C17 8.10938 17.0625 8.17187 17.0625 8.29688V9.70312C17.0625 9.82813 17 9.89062 16.875 9.89062H1.125C1 9.89062 0.9375 9.82813 0.9375 9.70312V8.29688C0.9375 8.17187 1 8.10938 1.125 8.10938Z"
                                        fill="white"
                                      />
                                    </svg>{" "}
                                    &nbsp; Add New Answer
                                  </Button>
                                </Flex>
                              ) : null}
                              <Flex>
                                <Flex
                                  color="white"
                                  fontSize="14px"
                                  lineHeight="1.4"
                                  fontWeight="500"
                                  mt="5px"
                                  py={2}
                                  alignItems="center"
                                  onClick={() => questionHandler(q.id)}
                                >
                                  <svg
                                    style={{
                                      display: "inline",
                                      marginTop: "4px",
                                    }}
                                    width="14"
                                    height="14"
                                    viewBox="0 0 14 14"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M12.334 0.333344H1.66732C0.931984 0.333344 0.333984 0.931343 0.333984 1.66668V9.66668C0.333984 10.402 0.931984 11 1.66732 11H3.66732V13.5113L7.85198 11H12.334C13.0693 11 13.6673 10.402 13.6673 9.66668V1.66668C13.6673 0.931343 13.0693 0.333344 12.334 0.333344ZM12.334 9.66668H7.48265L5.00065 11.1553V9.66668H1.66732V1.66668H12.334V9.66668Z"
                                      fill="#DCDEDF"
                                    />
                                  </svg>
                                  &nbsp;&nbsp;
                                  {q?.answers?.length > 0
                                    ? q.answers.length
                                    : null}{" "}
                                  answers
                                </Flex>
                              </Flex>
                            </Flex>
                          </Flex>
                        </Flex>
                      ))}
                    </Flex>
                    <Flex flexDir="column" mt={4} maxW="250px">
                      <Button
                        bg="background.yellow1"
                        mr={3}
                        color="white"
                        onClick={onOpen}
                      >
                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 18 18"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M8.29688 0.5625H9.70312C9.82812 0.5625 9.89062 0.625 9.89062 0.75V17.25C9.89062 17.375 9.82812 17.4375 9.70312 17.4375H8.29688C8.17187 17.4375 8.10938 17.375 8.10938 17.25V0.75C8.10938 0.625 8.17187 0.5625 8.29688 0.5625Z"
                            fill="white"
                          />
                          <path
                            d="M1.125 8.10938H16.875C17 8.10938 17.0625 8.17187 17.0625 8.29688V9.70312C17.0625 9.82813 17 9.89062 16.875 9.89062H1.125C1 9.89062 0.9375 9.82813 0.9375 9.70312V8.29688C0.9375 8.17187 1 8.10938 1.125 8.10938Z"
                            fill="white"
                          />
                        </svg>
                        &nbsp;Add New Question
                      </Button>
                    </Flex>
                  </Flex>
                </Flex>
              </Flex>
            </Flex>
          ) : (
            <Spinner color="white" />
          )}
        </Flex>

        {/* pageInfo ? (
          <>
            <Flex flexDir="column" width="95%" ml="20px" height="100%">
              <Flex color="white" fontSize="20px" fontWeight="400">
                <Breadcrumbs breadcrumbs={breadcrumbs} />
              </Flex>
              <Flex flexDir="column">
                <Text color="yellow" fontSize="24px" fontWeight="700">
                  Approval Page — {pageInfo.page.title}
                </Text>
                <Text color="white" fontSize="18px" fontWeight="600">
                  Project — {pageInfo.page.project.title}
                </Text>
              </Flex>

              {isa ? (
                <>
                  <Flex flexDir="column" mt="50px">
                    <Text color="white" fontSize="18px" fontWeight="700">
                      Approval Status
                    </Text>
                    {hasApproved ? (
                      <Button
                        bg="yellow1"
                        mt="10px"
                        color="white"
                        width="200px"
                        onClick={disapprovePage}
                      >
                        Reverse Approval
                      </Button>
                    ) : (
                      <Button
                        bg="yellow1"
                        mt="10px"
                        color="white"
                        width="200px"
                        onClick={approvePage}
                      >
                        Approve this Page
                      </Button>
                    )}
                  </Flex>

                  <Flex flexDir="column" mt="50px">
                    <Text color="white" fontSize="18px" fontWeight="700">
                      Post a Question/Comment
                    </Text>
                    <Button
                      bg="yellow1"
                      mt="10px"
                      color="white"
                      width="200px"
                      onClick={onOpen}
                    >
                      Click here to add
                    </Button>
                  </Flex>
                </>
              ) : null}

              <Flex flexDir="column" mt="50px" width="90%">
                <Text color="white" fontSize="18px" fontWeight="700" mb="5px">
                  View All Active Approval Blocks
                </Text>
                <Flex flexDir="row" flexWrap="wrap" width="100%">
                  {pageInfo.approvals.map((app, key) => (
                    <Flex
                      width="250px"
                      bg={app.approved ? "green" : "red"}
                      p="20px"
                      borderRadius="10px"
                      flexDir="column"
                      mr="10px"
                      mb="10px"
                    >
                      <Flex
                        flexDir="row"
                        width="100%"
                        justifyContent="space-between"
                        alignItems="flex-start"
                      >
                        <Text color="white" fontSize="16px" fontWeight="700">
                          APPROVAL {key + 1}
                        </Text>
                        {pageInfo.is_collaborator ? (
                          <Icon
                            as={BiTrash}
                            color="white"
                            height="18px"
                            width="18px"
                            cursor="pointer"
                            onClick={() => handleRemAppr(app.approver.email)}
                          />
                        ) : null}
                      </Flex>
                      <Text
                        color="white"
                        fontSize="16px"
                        textTransform="uppercase"
                        fontWeight="700"
                        mt="10px"
                      >
                        {app.approver.name}
                      </Text>
                    </Flex>
                  ))}
                </Flex>
              </Flex>

              <Flex flexDir="column">
                {isc || isa ? (
                  <>
                    <Button
                      bg="yellow1"
                      width="350px"
                      mt="50px"
                      color="white"
                      onClick={onOpen3}
                    >
                      Add Approval Blocks to this base block
                    </Button>
                  </>
                ) : null}
              </Flex>
              <Button
                width="350px"
                bg="grey3"
                mt="10px"
                color="white"
                onClick={() => (window.location = "/page/" + pageSlug)}
              >
                Back to Base Block
              </Button>
            </Flex>

            <Flex flexDir="column" height="100%" width="55%">
              <Text color="white" fontSize="18px" mt="50px" fontWeight="700">
                VIEW ALL QUESTIONS
              </Text>
              <Flex flexDir="column" height="600px" overflowY="scroll">
                {pageInfo.questions.map((q, key) => (
                  <Flex
                    width="95%"
                    mt="10px"
                    mb="10px"
                    bg="grey3"
                    p="10px"
                    pt="30px"
                    pb="30px"
                    alignItems="center"
                    justifyContent="flex-start"
                    borderRadius="10PX"
                    flexDir="row"
                    cursor="pointer"
                  >
                    <Flex flexDir="column" width="50px" alignItems="center">
                      <Image
                        src={uv}
                        boxSize="20px"
                        onClick={() => voteQuestion(q.id, "up")}
                        cursor="pointer"
                      />
                      <Text color="white" fontSize="24px" fontWeight="900">
                        {q.votes}
                      </Text>
                      <Image
                        src={dv}
                        boxSize="20px"
                        onClick={() => voteQuestion(q.id, "down")}
                        cursor="pointer"
                      />
                    </Flex>

                    <Flex flexDir="column" ml="20px" mr="20px" width="100%">
                      <Text
                        color="yellow"
                        fontSize="18px"
                        lineHeight="1.4"
                        fontWeight="700"
                        dangerouslySetInnerHTML={{ __html: q.question }}
                      />

                      <Text
                        color="white"
                        bg="grey1"
                        p="2px"
                        borderRadius="10px"
                        textTransform="uppercase"
                        width="fit-content"
                        pl="5px"
                        pr="5px"
                        fontSize="10px"
                        lineHeight="1.4"
                        fontWeight="700"
                        mt="2px"
                        mb="5px"
                      >
                        BY {q.author}
                      </Text>

                      {q.answers.map((a) => (
                        <>
                          <Text
                            color="grey1"
                            fontSize="18px"
                            lineHeight="1.4"
                            fontWeight="700"
                            mt="5px"
                          >
                            A. {a.answer}
                          </Text>

                          <Text
                            color="white"
                            bg="grey1"
                            p="2px"
                            borderRadius="10px"
                            textTransform="uppercase"
                            width="fit-content"
                            pl="5px"
                            pr="5px"
                            fontSize="10px"
                            lineHeight="1.4"
                            fontWeight="700"
                            mt="2px"
                            mb="5px"
                          >
                            BY {a.author}
                          </Text>
                        </>
                      ))}
                      <Flex flexDirection="row" flexBasis="">
                        {isc || isa ? (
                          <Button
                            bg="yellow1"
                            mt="10px"
                            size="sm"
                            color="white"
                            width="150px"
                            mr="3"
                            onClick={() => answerHandler(q.id)}
                          >
                            Answer Question
                          </Button>
                        ) : null}
                        <Button
                          bg="#4B555E"
                          mt="10px"
                          size="sm"
                          color="white"
                          width="150px"
                          onClick={() => questionHandler(q.id)}
                        >
                          Detailed View
                        </Button>
                      </Flex>
                    </Flex>
                  </Flex>
                ))}
              </Flex>
            </Flex>
          </>
        ) : (
          <Spinner color="white" />
        ) */}
      </Flex>

      <>
        <Modal isOpen={isOpen} onClose={onClose} isCentered size="xl">
          <ModalOverlay />
          <ModalContent bg="background.grey3" color="white">
            <ModalHeader>Add a Question/Comment</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
              <Text fontWeight="700" fontSize="18px" mb="5px">
                Add your query below
              </Text>
              <Flex color="background.grey3" className="">
                <Flex className="editPageForm2">
                  <CKEditor
                    data={value}
                    editor={ClassicEditor}
                    config={{
                      typing: {
                        transformations: {
                          remove: [
                            "symbols",
                            "quotes",
                            "arrowLeft",
                            "arrowRight",
                            "mathematical",
                            "typography",
                          ],
                        },
                      },
                      // width:['250px'],

                      toolbar: {
                        items: [
                          "heading",
                          "|",
                          "fontfamily",
                          "fontsize",
                          "fontColor",
                          "fontBackgroundColor",
                          "|",
                          "alignment",
                          "insertTable",
                          "|",
                          "bold",
                          "italic",
                          "strikethrough",
                          "underline",
                          "subscript",
                          "superscript",
                          "|",
                          "link",
                          "|",
                          "bulletedList",
                          "numberedList",
                          "todoList",
                          "undo",
                          "redo",
                          "|",
                          "highlight",
                          "|",
                          "specialCharacters",
                          "horizontalLine",
                          "removeFormat",
                          "|",
                        ],
                      },
                      width: ["250px"],
                    }}
                    onReady={(editor) => {
                      editor.editing.view.change((writer) => {
                        writer.setAttribute(
                          "spellcheck",
                          "false",
                          editor.editing.view.document.getRoot()
                        );
                        writer.setAttribute(
                          "autocomplete",
                          "off",
                          editor.editing.view.document.getRoot()
                        );
                        writer.setAttribute(
                          "autocorrect",
                          "off",
                          editor.editing.view.document.getRoot()
                        );
                      });
                    }}
                    onChange={(event, editor) => {
                      editorHandler(event, editor);
                    }}
                  />
                </Flex>{" "}
              </Flex>
            </ModalBody>

            <ModalFooter>
              <Button bg="background.yellow1" mr={3} onClick={postQuestion}>
                Submit
              </Button>
              <Button variant="ghost" onClick={onClose}>
                Cancel
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
      </>

      <>
        <Modal isOpen={isOpen2} onClose={onClose2} isCentered>
          <ModalOverlay />
          <ModalContent bg="background.grey3" color="white">
            <ModalHeader>Add an Answer</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
              <Text fontWeight="700" fontSize="18px" mb="5px">
                Add your answer below
              </Text>
              <Input placeholder="Enter answer" ref={answerRef} />
            </ModalBody>

            <ModalFooter>
              <Button bg="background.yellow1" mr={3} onClick={submitAnswer}>
                Submit
              </Button>
              <Button variant="ghost" onClick={onClose}>
                Cancel
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
      </>

      <>
        <Modal isOpen={isOpen3} onClose={onClose3} isCentered>
          <ModalOverlay />
          <ModalContent bg="background.grey3" color="white">
            <ModalHeader>Add Approvers</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
              <Text fontWeight="700" fontSize="18px" mb="5px">
                Enter emails as comma separated values
              </Text>
              <Input placeholder="Enter emails" ref={emailA} />
            </ModalBody>

            <ModalFooter>
              <Button bg="background.yellow1" mr={3} onClick={createApprovalPage}>
                Submit
              </Button>
              <Button variant="ghost" onClick={onClose3}>
                Cancel
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
      </>
      <>
        <Modal isOpen={isOpen4} onClose={onClose4} isCentered size="xl">
          <ModalOverlay />
          <ModalContent bg="background.grey0" color="white">
            <ModalHeader>Question Detailed View</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
              <Flex flexDir="row" flexWrap="wrap" width="100%">
                {pageInfo && question.id && (
                  <Flex
                    width="100%"
                    mb="10px"
                    bg="background.grey3"
                    p="10px"
                    alignItems="center"
                    justifyContent="flex-start"
                    borderRadius="10PX"
                    flexDir="row"
                    cursor="pointer"
                  >
                    <Flex
                      flexDir="column"
                      width="30px"
                      alignItems="center"
                      mt="7px"
                    >
                      <Image
                        src={uv}
                        boxSize="15px"
                        onClick={() => voteQuestion(question.id, "up")}
                        cursor="pointer"
                      />
                      <Text color="white" fontSize="18px" fontWeight="900">
                        {question.votes}
                      </Text>
                      <Image
                        src={dv}
                        boxSize="15px"
                        onClick={() => voteQuestion(question.id, "down")}
                        cursor="pointer"
                      />
                    </Flex>

                    <Flex flexDir="column" ml="20px" mr="20px" width="100%">
                      <Text
                        color="white"
                        fontSize="18px"
                        lineHeight="1.4"
                        fontWeight="700"
                        dangerouslySetInnerHTML={{ __html: question.question }}
                      />
                      <Flex>
                        <Text color="white" fontSize="12px" fontWeight="900">
                          Asked By: {question.author.email}
                        </Text>
                      </Flex>
                      <Divider
                        orientation="horizontal"
                        style={{
                          border: "1px solid  rgba(255, 255, 255, 0.44)",
                          marginTop: "2%",
                        }}
                      />
                      <Text
                        mt={2}
                        color="rgba(255, 255, 255, 0.64)"
                        fontSize="19px"
                        fontWeight="900"
                      >
                        Provided answers:
                      </Text>
                      {question &&
                        question.answers.map((a) => (
                          <>
                            <Text
                              color="white"
                              fontSize="16px"
                              lineHeight="1.4"
                              fontWeight="500"
                              style={{ marginTop: "5%" }}
                            >
                              {a.answer}
                            </Text>

                            <Flex
                              flexDir="row"
                              bg
                              justifyContent="space-between"
                              alignItems="center"
                              // borderTop="2px solid  rgba(255, 255, 255, 0.24)"
                            >
                              {question?.answers?.length > 0 ? (
                                <>
                                  {/* <Flex mt={3}>
                                  <Avatar
                                    size="sm"
                                    bg="white"
                                    name={question.answers[0].author}
                                    src={question.answers[0].author}
                                    color="#2D3842"
                                    fontWeight="700"
                                    mr={2}
                                  />

                                  <Text
                                    color="white"
                                    fontSize="14px"
                                    lineHeight="1.4"
                                    fontWeight="500"
                                    mt="5px"
                                  >
                                    {question.answers[0].author}
                                  </Text>
                                </Flex> */}
                                  <Text
                                    color="rgba(255, 255, 255, 0.74)"
                                    p="2px"
                                    borderRadius="10px"
                                    width="fit-content"
                                    pr="5px"
                                    fontSize="12px"
                                    lineHeight="1.4"
                                    fontWeight="700"
                                    mb="10px"
                                  >
                                    By {a.author.email},{" "}
                                    <ReactTimeAgo
                                      date={a.created_on}
                                      locale="en-US"
                                    />
                                    .
                                  </Text>
                                </>
                              ) : null}
                              <Flex mt="5px">
                                <Flex
                                  color="white"
                                  fontSize="14px"
                                  lineHeight="1.4"
                                  fontWeight="500"
                                  mt="5px"
                                  alignItems="center"
                                >
                                  {/* <svg style={{ display: 'inline', marginTop: '4px' }} width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path
                                      d="M12.334 0.333344H1.66732C0.931984 0.333344 0.333984 0.931343 0.333984 1.66668V9.66668C0.333984 10.402 0.931984 11 1.66732 11H3.66732V13.5113L7.85198 11H12.334C13.0693 11 13.6673 10.402 13.6673 9.66668V1.66668C13.6673 0.931343 13.0693 0.333344 12.334 0.333344ZM12.334 9.66668H7.48265L5.00065 11.1553V9.66668H1.66732V1.66668H12.334V9.66668Z"
                                      fill="#DCDEDF"
                                    />
                                  </svg> */}
                                  &nbsp;&nbsp;
                                  {/* {question?.answers?.length > 0 ? question.answers.length : null} answers */}
                                </Flex>
                              </Flex>
                            </Flex>
                          </>
                        ))}
                    </Flex>
                  </Flex>
                )}
                {isc || isa ? (
                  <Button
                    bg="background.yellow1"
                    mt="10px"
                    size="sm"
                    color="white"
                    width="150px"
                    mr="3"
                    onClick={() => answerHandler(question.id)}
                  >
                    <svg
                      width="18"
                      height="18"
                      viewBox="0 0 18 18"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M8.29688 0.5625H9.70312C9.82812 0.5625 9.89062 0.625 9.89062 0.75V17.25C9.89062 17.375 9.82812 17.4375 9.70312 17.4375H8.29688C8.17187 17.4375 8.10938 17.375 8.10938 17.25V0.75C8.10938 0.625 8.17187 0.5625 8.29688 0.5625Z"
                        fill="white"
                      />
                      <path
                        d="M1.125 8.10938H16.875C17 8.10938 17.0625 8.17187 17.0625 8.29688V9.70312C17.0625 9.82813 17 9.89062 16.875 9.89062H1.125C1 9.89062 0.9375 9.82813 0.9375 9.70312V8.29688C0.9375 8.17187 1 8.10938 1.125 8.10938Z"
                        fill="white"
                      />
                    </svg>{" "}
                    &nbsp; Add New Answer
                  </Button>
                ) : null}
              </Flex>
            </ModalBody>
          </ModalContent>
        </Modal>
      </>
    </>
  );
};

export default Approval;
